import React from 'react'
import { Link } from 'gatsby'
import Img from 'gatsby-image'
import { Flex, Text, Box } from 'theme-ui'
import { ContentfulResource } from 'graphqlTypes'

export const Card = ({ card }: { card: ContentfulResource }) => {
  return (
    <Flex
      sx={{
        flexDirection: ['column'],
      }}
    >
      <Text
        sx={{
          mb: [1],
          color: 'grey',
          fontFamily: 'Futura Book Regular',
          fontSize: [3],
        }}
      >
        <Link
          to={`/about/${card?.authorAbout?.slug}`}
          activeClassName="active"
          style={{ textDecoration: 'none', color: '#434343' }}
        >
          {card?.authorAbout?.name ?? card?.author}
        </Link>
      </Text>
      <Link to={`/resources/${card.slug}`}>
        <CardCoverImage card={card} />
      </Link>
      <Text
        sx={{
          mt: '15px',
          fontSize: [null, null, null, 3, 3],
          fontFamily: 'Futura Medium',
          color: '#747474',
        }}
      >
        {(card?.disciplines && card.disciplines[0]) || 'Science'}
      </Text>
      <Text
        sx={{
          mt: [null, null, null, 1, 0],
          fontSize: [null, null, null, 3, 4],
          fontFamily: 'Futura Bold',
          color: 'black',
          maxWidth: '300px',
        }}
      >
        {card?.title}
      </Text>
    </Flex>
  )
}

const CardCoverImage = ({ card }: { card: ContentfulResource }) => {
  return card?.coverImage ? (
    <Img
      fixed={card?.coverImage?.fixed || {}}
      key={card?.coverImage?.fixed?.src}
      alt={`Image for ${card?.title}`}
      style={{ border: '1px solid lightgrey' }}
    />
  ) : (
    <Box
      sx={{
        width: ['300px'],
        height: ['300px'],
        bg: 'grey',
      }}
    />
  )
}
